<mat-form-field class="form-full-width" appearance="outline" [formGroup]="group">
    <mat-label>{{ field.label }}</mat-label>
    <mat-date-range-input [rangePicker]="inputDatepicker" [dateFilter]="dataFilter">
        <input
            matStartDate
            matInput
            [formControlName]="field.name + '_min'"
            [id]="field.id ? field.id : null"
            [disabled]="field.disabled"
            [readonly]="field.disabled"
        />
        <input
            matEndDate
            matInput
            [formControlName]="field.name + '_max'"
            [id]="field.id ? field.id : null"
            [disabled]="field.disabled"
            [readonly]="field.disabled"
        />
    </mat-date-range-input>
    <mat-date-range-picker #inputDatepicker [dateClass]="data"></mat-date-range-picker>
    <mat-datepicker-toggle
        matSuffix
        [matTooltip]="appService.language_dictionary.system_calendar"
        [for]="inputDatepicker"
    >
    </mat-datepicker-toggle>
    <mat-hint *ngIf="field.hint" [innerHtml]="field.hint"></mat-hint>
    <button
        mat-button
        *ngIf="(group.get(field.name + '_min').value || group.get(field.name + '_max').value) && !field.disabled"
        matSuffix
        tabindex="-1"
        mat-icon-button
        title="{{ appService.language_dictionary.system_clear }}"
        (click)="
            group.get(field.name + '_min').setValue(null);
            group.get(field.name + '_max').setValue(null);
            group?.get(field.name + '_min')?.markAsDirty();
            group?.get(field.name + '_max')?.markAsDirty()
        "
    >
        <mat-icon fontSet="mdi" fontIcon="mdi-close"></mat-icon>
    </button>
    <ng-container *ngFor="let validation of field.validations" ngProjectAs="mat-error">
        <mat-error
            *ngIf="group?.get(field.name)?.hasError(validation.name)"
            [innerHTML]="
                validation.name === 'serverError' ? group?.get(field.name)?.errors?.serverError : validation.message
            "
        >
        </mat-error>
    </ng-container>
    <mat-error *ngIf="group.get(field.name + '_min').hasError('inputMaskError')">
        {{ group.get(field.name + '_min').errors?.inputMaskError }}
    </mat-error>
    <mat-error *ngIf="group.get(field.name + '_max').hasError('inputMaskError')">
        {{ group.get(field.name + '_max').errors?.inputMaskError }}
    </mat-error>
</mat-form-field>
